import React, { FC } from 'react';
import useSubjects from '../hooks/useSubjects';
import useRegions from '../hooks/useRegions';
import SingleSelect from '../lib/components/SingleSelect';
import { SelectOption } from '../typings/select-option.typings';

interface Props {
  disabled?: boolean;
  label?: string;
  onChange: (val: SelectOption) => void;
  value: string;
}

export const UfSelect: FC<Props> = ({
  disabled,
  label = 'UF',
  onChange,
  value,
}) => {
  const regions = useRegions();
  const regionsList = regions.getList();

  return (
    <SingleSelect
      label={label}
      name="uf"
      placeholder="UF"
      disabled={disabled}
      value={value}
      onChange={onChange}
      options={regionsList.map((r) => ({
        value: r.id,
        label: r.id,
      }))}
    />
  );
};

interface InstProps extends Props {
  region: string;
}

export const InstitutionSelect: FC<InstProps> = ({
  disabled,
  label = 'Instituição',
  onChange,
  region,
  value,
}) => {
  const regions = useRegions();

  return (
    <SingleSelect
      label={label}
      name="institution"
      placeholder="Instituição"
      onChange={onChange}
      value={value}
      disabled={disabled}
      options={region && !regions.loading
        ? [
          {
            value: '',
            label: 'Todas',
          },
          ...regions.data[region].institutions
            .sort((a: { name: string }, b: { name: string }) => {
              if (a.name < b.name) {
                return -1;
              }
              return 1;
            })
            .map((institution: { _id: string; name: string }) => ({
              value: institution._id,
              label: institution.name,
            })),
        ]
        : []}
    />
  );
};

export const AreaSelect: FC<Props> = ({
  value,
  disabled,
  onChange,
}) => {
  const classifications = useSubjects();

  return (
    <SingleSelect
      isClearable={false}
      label="Área"
      name="area"
      placeholder="Área"
      onChange={onChange}
      disabled={disabled || classifications.loading}
      value={classifications.loading ? '' : value}
      options={[
        ...classifications.getList().map((c) => ({
          value: c._id,
          label: c.name,
        })),
      ]}
    />
  );
};
